import {
    SET_CM_CREDIT_CARD_BANNER_DATA,
    GET_CM_CREDIT_CARD_BANNER_DATA_ERROR,
} from '../actionTypes/CMCreditCardBannerDataActionTypes';

function CMCreditCardBannerReducer(state = {}, action) {
    switch (action.type) {
        case SET_CM_CREDIT_CARD_BANNER_DATA:
            return { content: action.content, isError: action.isError };
        case GET_CM_CREDIT_CARD_BANNER_DATA_ERROR:
            return action.errorHandlerInfo;
        default:
            return state;
    }
}

export default CMCreditCardBannerReducer;
